// src/utils/packHelpers.js
// Migrated verbatim from prototype/between-the-lines-v2.html lines 1642-1646.

import { PACK_TEMPLATES } from '../config/packTemplates.js';

export const getPackType = (pack) => {
    if (!pack) return 'set-text';
    if (pack.packType && PACK_TEMPLATES[pack.packType]) return pack.packType;
    return 'set-text';
};

// Bundle clarity: the series (bundle) pack in `packs` whose memberPackIds
// includes `packId`, or null. Used to relabel a bundle-only member card
// ("Included in the {bundle}") and point the shopper at the purchasable bundle.
export const findParentBundle = (packs, packId) =>
    (packs || []).find((p) =>
        getPackType(p) === 'series'
        && Array.isArray(p.memberPackIds)
        && p.memberPackIds.includes(packId)) || null;
